import {
  LayoutDashboard, Users, FileText, Database, ClipboardCheck, BarChart3,
  BookOpen, Trophy, ShieldCheck,
} from "lucide-react";

export const adminNav = [
  { key: "dashboard", label: "Dashboard", to: "/admin", icon: LayoutDashboard },
  { key: "students", label: "Students", to: "/admin/students", icon: Users },
  { key: "exams", label: "Examinations", to: "/admin/exams", icon: FileText },
  { key: "bank", label: "Question Bank", to: "/admin/question-bank", icon: Database },
  { key: "evaluations", label: "Evaluations", to: "/admin/evaluations", icon: ClipboardCheck },
  { key: "analytics", label: "Analytics", to: "/admin/analytics", icon: BarChart3 },
  { key: "admins", label: "Administrators", to: "/admin/admins", icon: ShieldCheck },
];

export const studentNav = [
  { key: "dashboard", label: "Dashboard", to: "/app", icon: LayoutDashboard },
  { key: "exams", label: "Examinations", to: "/app/exams", icon: BookOpen },
  { key: "results", label: "Results", to: "/app/results", icon: Trophy },
];
